/* ══ F15 4.2 — THE ONE TAP: a deload the logged numbers call for, PROPOSED to the coach (his 10-31 word, decision 6) ════════
 * The planners (`_shared/nextWeekWriter.ts` `proposeDeload`, the phone's `proposeIfCalled`) write one row per client and week
 * into `coach_deload_proposals` when a program does not deload automatically. The client's week shows the open one:
 * "Numbers fell two sessions running" · "Deload this week" (→ `apply-next-week` mode "deload") / "Not now" (→ declined). */

export interface DeloadProposalRow { week_start: string; reason: string; decided: string | null }

export const PROPOSAL_LINE = "Numbers fell two sessions running";
export const PROPOSAL_DECLINE = "Not now";

/** The open proposal to show: undecided, for this week or a later one, the EARLIEST first. Null = nothing to show. */
export function openProposal(rows: readonly DeloadProposalRow[], thisMonday: string): DeloadProposalRow | null {
  const open = rows.filter((r) => r.decided === null && r.week_start.slice(0, 10) >= thisMonday)
    .sort((a, b) => (a.week_start < b.week_start ? -1 : a.week_start > b.week_start ? 1 : 0));
  return open[0] ?? null;
}

/** The accept button: "Deload this week" for this week's Monday, "Deload week of 9 Nov" for a later one. */
export function acceptLabel(weekStart: string, thisMonday: string): string {
  if (weekStart.slice(0, 10) === thisMonday) return "Deload this week";
  const d = new Date(`${weekStart.slice(0, 10)}T00:00:00Z`);
  return `Deload week of ${d.getUTCDate()} ${d.toLocaleString("en-GB", { month: "short", timeZone: "UTC" })}`;
}

/** The body the accept sends to `apply-next-week` (its mode "deload"). */
export const acceptBody = (clientId: string, weekStart: string) =>
  ({ mode: "deload" as const, clientId, weekStart: weekStart.slice(0, 10) });
